import axioApi, { setHeader } from 'api/root.api';

export const visitGet = async (token)=>{
    const urlEnd = '/publish/v1/product/visit/currentMonth';
    setHeader('Authorization', `Bearer ${token}`);
    const response = await axioApi.get(urlEnd);
    const result = response.data;
    return result;
};